import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS = Symbol('admin.profile-settings');
export const TRANSLATION_GROUP_AFFILIATE_PROFILE_SETTINGS = Symbol('affiliate.profile-settings');

export const ADMIN_PROFILE_SETTINGS_ROUTE_NAME = Symbol('admin.profile-settings');
export const AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME = Symbol('affiliate.profile-settings');

export const ADMIN_PROFILE_SETTINGS_URL = 'admin/profile/edit';
export const ADMIN_PROFILE_SETTINGS_QUERY_KEY = 'admin.profile-settings.get';

export const AFFILIATE_PROFILE_SETTINGS_URL = 'affiliate/settings/edit';
export const AFFILIATE_PROFILE_SETTINGS_QUERY_KEY = 'affiliate.profile-settings.get';

export const PROFILE_SETTINGS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.PROFILE_EDIT, PermissionsList.affiliate.SETTINGS_SHOW),
  EDIT: new Permission(PermissionsList.admin.PROFILE_EDIT, PermissionsList.affiliate.SETTINGS_EDIT),
  PAYMENT_SYSTEMS: new Permission(undefined, PermissionsList.affiliate.PAYMENTSYSTEMS_SHOW),
  PAYMENT_SYSTEMS_UPDATE: new Permission(undefined, PermissionsList.affiliate.PAYMENTSYSTEMS_UPDATE),
  TWO_FACTOR_AUTH: new Permission(PermissionsList.admin.TWO_FACTOR_AUTH, PermissionsList.affiliate.TWO_FACTOR_AUTH),
};
